"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var selection_1 = require("./selection");
var flights_1 = require("./flights");
var State = /** @class */ (function () {
    // create everything with initial defaults
    function State() {
        // price differ amount for current connection
        this.priceDiffer = 0;
        // price difference for flights
        this.priceDifference = 0;
        this.selectedConnection = null;
        // cache mandatory Roundtrip value
        this.mandatoryRoundtrip = false;
        // api call status: cache last url fragment
        this.loading = '';
        // return only roundtrips
        this.roundtripsOnly = false;
        // set to false if options 'Kein Hinflug/Kein Rückflug' should be avoided (e.g. PAUSCHAL)
        this.withNoFlight = true;
        // set to false if option 'Kein Hinflug' should be avoided (e.g. PAUSCHAL)
        this.withOutNoFlight = true;
        // set to false if option 'Kein Rückflug' should be avoided (e.g. PAUSCHAL)
        this.withRetNoFlight = true;
        this.flightsOutTouched = false;
        this.flightsRetTouched = false;
        // whether the respective RNF direction is selected (or not selected) by the user
        this.rnfDeparture = false;
        this.rnfArrival = false;
        // selected rail class, i.e. '1', '2'
        this.rnfCategory = '2';
        // response from iris for selected rail to/from gateway
        this.rnfTransportations = [];
        this.rnfTotalPrice = 0;
        this.outgoingSelection = new selection_1.Selection();
        this.returningSelection = new selection_1.Selection();
        this.flights = new flights_1.Flights();
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map